module.exports = __webpack_public_path__ + "conheca/static/media/bolacha.e60a0aeb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Eventos/bolacha.jpeg
// module id = 392
// module chunks = 37